import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/donations/medical";

export const Route = createFileRoute("/admin/_donations/medical")({
  component: Page,
});
